"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockServiceConn = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
function mockServiceConn(overrides) {
    return Object.assign({
        serviceConnUid: 'fake0service0conn0for0test',
        accessType: constants_iso_1.ServiceAccessType.IORedis,
    }, overrides);
}
exports.mockServiceConn = mockServiceConn;
//# sourceMappingURL=mock-service-conn.js.map